// Catalog of car parts. The 12 numbered panels match the user-uploaded image
// "imagen para presupuestos.png". Two extra parts (montantes I/D) have no
// number and are NOT clickable — they appear in the side list only.

// Imagen servida desde frontend/public/assets/car.png
export const CAR_IMAGE_URL = "/assets/car.png";

export const PARTS = [
  { number: 1, key: "aleta_del_izq", name: "Aleta delantera izquierda", part_kind: "aleta" },
  { number: 2, key: "aleta_del_der", name: "Aleta delantera derecha", part_kind: "aleta" },
  { number: 3, key: "aleta_tras_izq", name: "Aleta trasera izquierda", part_kind: "aleta" },
  { number: 4, key: "aleta_tras_der", name: "Aleta trasera derecha", part_kind: "aleta" },
  { number: 5, key: "puerta_del_izq", name: "Puerta delantera izquierda", part_kind: "puerta" },
  { number: 6, key: "puerta_del_der", name: "Puerta delantera derecha", part_kind: "puerta" },
  { number: 7, key: "puerta_tras_izq", name: "Puerta trasera izquierda", part_kind: "puerta" },
  { number: 8, key: "puerta_tras_der", name: "Puerta trasera derecha", part_kind: "puerta" },
  { number: 9, key: "capo", name: "Capó", part_kind: "capo" },
  { number: 10, key: "techo", name: "Techo", part_kind: "techo" },
  { number: 11, key: "maletero_alto", name: "Maletero alto", part_kind: "techo" },
  { number: 12, key: "maletero_bajo", name: "Maletero bajo", part_kind: "techo" },
  // Montantes — sin número, no clicables en la imagen, sí seleccionables en la lista
  { number: null, key: "montante_izq", name: "Montante izquierdo", part_kind: "montante" },
  { number: null, key: "montante_der", name: "Montante derecho", part_kind: "montante" },
];

export const PART_BY_KEY = Object.fromEntries(PARTS.map((p) => [p.key, p]));

export const PART_KINDS = ["aleta", "capo", "montante", "puerta", "techo"];
